import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';
import Tabs from '../../../components/Tabs/Tabs';
import useMobile from '../../../hooks/useMobileHook';
import VerificationOfCoverageMedical from './verificationOfCoverageMedical';
import VerificationOfCoverageDental from './verificationOfCoverageDental';
import VerificationOfCoverageVision from './verificationOfCoverageVision';

const tabsData = [
  {
    name: 'Medical',
    content: <VerificationOfCoverageMedical />,
    leftIcon: <FontAwesomeIcon icon={light('heart-pulse')} />,
  },
  {
    name: 'Dental',
    content: <VerificationOfCoverageDental />,
    leftIcon: <FontAwesomeIcon icon={light('tooth')} />,
  },
  {
    name: 'Vision',
    content: <VerificationOfCoverageVision />,
    leftIcon: <FontAwesomeIcon icon={light('glasses')} />,
  },
];

export type VerificationCoverageModalProps = {
  showVerificationCoverageModal: boolean;
  handleCloseVerificationCoverageModal: () => void;
};

function VerificationCoverageModal({
  showVerificationCoverageModal,
  handleCloseVerificationCoverageModal,
}: VerificationCoverageModalProps) {
  const isFullscreen = useMobile();

  return (
    <>
      <Modal
        fullscreen={isFullscreen}
        className={'p-0'}
        show={showVerificationCoverageModal}
        onHide={handleCloseVerificationCoverageModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader closeButton={true}>
          <Row>
            <Col className={'col-12'}>
              <h4 className="text-sm-20-lg-24">Verification of Coverage</h4>
            </Col>

            <Col className={'col-12'}>
              <span className={'lh-xxs text-fs-6 fw-light text-dark-gray'}>
                As of today
              </span>
            </Col>
          </Row>
        </ModalHeader>
        <Modal.Body>
          <Container className={'px-0'}>
            <Tabs tabs={tabsData} />
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseVerificationCoverageModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VerificationCoverageModal;
